import { isEmptyObject } from "../Utility";

export const templateTypes = {
  leo_template: {
    id: 1,
    type: "leo_template",
  },
  website_template: {
    id: 2,
    type: "website_template",
  },
  default: {
    id: 3,
    type: "default",
  },
};

const getTemplateType = (memberData) => {
  if (!memberData)
    return {
      type: null,
      templateTheme: null,
    };
  if (memberData[templateTypes.leo_template.type]) {
    if (isEmptyObject(memberData[templateTypes.leo_template.type]))
      return {
        type: templateTypes.leo_template.type,
        templateTheme: null,
      };
    return {
      type: templateTypes.leo_template.type,
      templateTheme: memberData?.travel_agent_design_palette_config,
    };
  }
  if (memberData[templateTypes.website_template.type]) {
    if (isEmptyObject(memberData[templateTypes.website_template.type]))
      return {
        type: templateTypes.website_template.type,
        templateTheme: null,
      };

    return {
      type: templateTypes.website_template.type,
      templateTheme: memberData?.travel_agent_design_palette_config,
    };
  }
  return {
    type: null,
    templateTheme: null,
  };
};

export default getTemplateType;
